import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ApiClient } from '../common/api-client.service';

interface Ledger {
  name: string;
}

@Component({
  templateUrl: './ledger.component.html'
})
export class LedgerSettingsComponent implements OnInit {
  ledger: Ledger = {name: null};

  constructor(
    private apiClient: ApiClient,
    private router: Router,
  ) {}

  ngOnInit() {
    this.apiClient.get<Ledger>('/api/v1/ledger').toPromise().then(l => this.ledger = l);
  }

  save() {
    this.apiClient.patch<Ledger>('/api/v1/ledger', this.ledger).toPromise().then(l => {
      this.router.navigateByUrl('/account')
    }, resp => {
      // TODO
      alert(resp.error.errors);
    })
  }
}



// WEBPACK FOOTER //
// /srv/src/app/settings/ledger.component.ts